import { render, staticRenderFns } from "./PowerToday.vue?vue&type=template&id=36dcc3aa&scoped=true&"
import script from "./PowerToday.vue?vue&type=script&lang=js&"
export * from "./PowerToday.vue?vue&type=script&lang=js&"
import style0 from "./PowerToday.vue?vue&type=style&index=0&id=36dcc3aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dcc3aa",
  null
  
)

export default component.exports